import PropTypes from 'prop-types';
import classNames from 'classnames';
import kebabCase from 'lodash/kebabCase';
import {
  VibeButton,
  VibeIcon,
  viTableChart,
  color,
} from 'vibeguide';

function ReportCard({
  className = '',
  style = {},
  name,
}) {
  return (
    <div
      className={classNames('ReportCard', className)}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 32,
        width: 360,
        padding: 32,
        backgroundColor: color.white,
        border: `1px solid ${color.whiteSmoke}`,
        borderRadius: 4,
        ...style,
      }}
      data-testid={`report-card-${kebabCase(name)}`}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: 56,
          height: 56,
          backgroundColor: color.primary,
          borderRadius: '100%',
        }}
      >
        <VibeIcon
          icon={viTableChart}
          color={color.white}
          size={28}
        />
      </div>

      <div
        style={{
          flexGrow: 1,
          fontsize: 24,
          lineHeight: '32px',
          fontWeight: 600,
        }}
      >
        {name}
      </div>

      <div>
        <VibeButton
          text="View Report"
          color="secondary"
          link={`/reporting/report/${kebabCase(name)}`}
          testId={`report-card-${kebabCase(name)}-view-button`}
        />
      </div>
    </div>
  );
}

ReportCard.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  name: PropTypes.string.isRequired,
};

export default ReportCard;
